import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { BookOpen } from 'lucide-react';
import { getLegalActsRegister } from '../../../api/legalActs';
import { apiErrorMessage } from '../../../lib/apiError';
import { showErrorToast } from '../../../lib/errorToast';
/**
 * Récapitulatif annuel des délibérations ou des arrêtés publiés, pour aider à tenir le
 * registre papier. Il ne remplace pas le registre.
 */
export function RegisterExport() {
    const currentYear = new Date().getFullYear();
    const [kind, setKind] = useState('deliberations');
    const [year, setYear] = useState(currentYear);
    const [pending, setPending] = useState(false);
    // Fenêtre ouverte avant l'attente : ouverte après, le navigateur la bloquerait.
    const download = async () => {
        const win = window.open('', '_blank');
        setPending(true);
        try {
            const blob = await getLegalActsRegister(year, kind);
            const url = URL.createObjectURL(blob);
            if (win)
                win.location.href = url;
            setTimeout(() => URL.revokeObjectURL(url), 60000);
        }
        catch (err) {
            win?.close();
            showErrorToast(apiErrorMessage(err, 'Le récapitulatif n\'a pas pu être produit.'));
        }
        finally {
            setPending(false);
        }
    };
    return (_jsxs("div", { className: "mt-6 bg-white rounded-lg border border-gray-200 p-4 flex flex-wrap items-center gap-2", children: [_jsx(BookOpen, { size: 16, className: "text-gray-500" }), _jsx("span", { className: "text-sm text-gray-700 mr-2", children: "Aide \u00E0 la tenue du registre :" }), _jsxs("select", { value: kind, onChange: (e) => setKind(e.target.value), className: "px-3 py-1.5 border rounded-lg text-sm", "aria-label": "Registre", children: [_jsx("option", { value: "deliberations", children: "D\u00E9lib\u00E9rations" }), _jsx("option", { value: "arretes", children: "Arr\u00EAt\u00E9s" })] }), _jsx("select", { value: year, onChange: (e) => setYear(Number(e.target.value)), className: "px-3 py-1.5 border rounded-lg text-sm", "aria-label": "Ann\u00E9e", children: Array.from({ length: 6 }, (_, i) => currentYear - i).map((y) => _jsx("option", { value: y, children: y }, y)) }), _jsx("button", { onClick: download, disabled: pending, className: "px-3 py-1.5 border rounded-lg text-sm hover:bg-gray-50 disabled:opacity-50", children: pending ? 'Préparation…' : 'Télécharger le récapitulatif (PDF)' }), _jsx("p", { className: "basis-full text-xs text-gray-400", children: "Actes publi\u00E9s de l'ann\u00E9e, dans l'ordre chronologique. Ce r\u00E9capitulatif aide \u00E0 tenir le registre papier, il ne le remplace pas." })] }));
}
